export default "__VITE_ASSET__Jd50Z2g6__"